var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { trackGraphQlError } from './errorUtils';
// Pricing page load actions
export var PRICING_BOOK_PAGE_LOAD = 'pricing-book-page-load';
export var PRICING_BENEFITS_PAGE_LOAD = 'pricing-benefits-page-load';
export var PRICING_BOOK_NATIONAL_ENROLL = 'pricing-book-national-enroll';
export var PRICING_BOOK_NATIONAL_UNENROLL = 'pricing-book-national-unenroll';
// Rewards Hub page load actions
export var REWARDS_HUB_PAGE_LOAD = 'rewards-hub-page-load';
// Rewards Hub drawer actions
export var REWARDS_HUB_DRAWER_OPEN = 'rewards-hub-drawer-open';
export var REWARDS_HUB_DRAWER_CLOSE = 'rewards-hub-drawer-close';
export var REWARDS_HUB_OFFERS_LIST_VIEW = 'rewards-hub-offers-list-view';
export var REWARDS_HUB_PERKS_LIST_VIEW = 'rewards-hub-perks-list-view';
export var REWARDS_HUB_PERK_OPTIONS_VIEW = 'rewards-hub-perk-options-view';
export var REWARDS_HUB_PERK_PROGRESS_VIEW = 'rewards-hub-perk-progress-view';
// Challenge actions
export var REWARDS_HUB_CHALLENGE_VIEW = 'rewards-hub-challenge-view';
export var REWARDS_HUB_CHALLENGE_JOIN = 'rewards-hub-challenge-join';
export var REWARDS_HUB_CHALLENGE_JOIN_SUCCESS = 'rewards-hub-challenge-join-success';
export var REWARDS_HUB_CHALLENGE_JOIN_ERROR = 'rewards-hub-challenge-join-error';
export var REWARDS_HUB_CHALLENGE_DEEP_LINK = 'rewards-hub-challenge-deep-link';
export var REWARDS_HUB_CHALLENGE_API_ERROR = 'rewards-hub-challenge-api-error';
export var REWARDS_HUB_CHALLENGE_API_SUCCESS_LOAD = 'rewards-hub-challenge-api-success-load';
export var REWARDS_HUB_CHALLENGE_NAVIGATION_BACK = 'rewards-hub-challenge-navigation-back';
// Perk actions
export var REWARDS_HUB_PERK_HISTORY_VIEW = 'rewards-hub-perk-history-view';
export var REWARDS_HUB_PERK_DEEP_LINK = 'rewards-hub-perk-deep-link';
// Offer actions
export var REWARDS_HUB_OFFER_VIEW = 'rewards-hub-view-all-offers';
export var REWARDS_HUB_OFFER_CLICK = 'rewards-hub-offer-click';
export var REWARDS_HUB_OFFER_DEEP_LINK = 'rewards-hub-offer-deep-link';
// Paint Benefit Card CTA
export var REWARDS_HUB_PAINT_VIEW_HISTORY_CLICK = 'rewards-hub-paint-view-history-click';
// Error states
export var REWARDS_HUB_AUTH_ERROR = 'rewards-hub-auth-error';
export var newrelic = {
    addPageAction: function (name, value) {
        var _a;
        if (typeof window !== 'undefined' &&
            ((_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) instanceof Function) {
            window.newrelic.addPageAction(name, value);
        }
    },
};
export var logNewRelicAction = function (action, error, additionalData) {
    newrelic.addPageAction(action, __assign(__assign({}, (error
        ? __assign(__assign({}, trackGraphQlError(error)), { result: 'error' }) : { result: 'success' })), additionalData));
};
